import React from 'react'

import LoaderSingleComponent from '../../loader-app/modules/LoaderSingleComponent'
import TableOneRowTransposed from '../../tables/modules/TableOneRowTransposed'

import Chip from '@material-ui/core/Chip'
import ErrorIcon from '@material-ui/icons/Error'

import {selectFieldsFromObj} from '../../arrays/api'
import {
    entity_get,
    entity_fields_info,
    mergeFieldsPropsAndFieldsInfo
} from '../services/api'
import { EntitySchema } from '../../../services/EntitySchema'
import { tableSchema } from '../../../services/EntityTableSchema'
import { fieldsViewSchema } from '../../../services/EntityFieldsSchema'

import DashboardCard from '../../cards/modules/DashboardCard'

class ViewEntity extends React.Component{
    constructor(props) {
        super(props)

        this.state = {
            data: [],
            fields_info: {},
        }
    }
    async componentDidMount() {
        await this._get()
    }
    async componentDidUpdate(prevProps) {
        const entity = this.props.entity
        const prev_entity = prevProps.entity
        const id_entity = this.props.id_entity
        const prev_id_entity = prevProps.id_entity

        if( entity !== prev_entity || id_entity !== prev_id_entity ) {
            await this._get()
        }
    }
    async _get() {
        const id_entity = this.props.id_entity
        const entity = this.props.entity

        const data = await entity_get(entity,id_entity)
        const fields_info = await entity_fields_info(entity)
        this.setState({
            data: data,
            fields_info: fields_info,
        })
        const onGetData = this.props.hasOwnProperty('onGetData')
            ? this.props.onGetData
            : () => {}
        await onGetData(this.state.data)
    }

    render() {
        const entity = this.props.entity
        const id_entity = this.props.id_entity
        const entityObj = EntitySchema.hasOwnProperty(entity) ? EntitySchema[entity] : {}
        if( !entity || !entityObj || !Object.keys(entityObj).length )
            return <Chip icon={<ErrorIcon />} label="Unmanaged entity" variant="outlined" />

        const fields = this.props.hasOwnProperty('fields') ? this.props.fields : fieldsViewSchema(entity)
        let data = this.state.data
        if(fields.length) {
            data = selectFieldsFromObj( data,fields )
        }
        if( !Object.keys(data).length )
            return <LoaderSingleComponent width="100%" />

        let fieldsProps = tableSchema(entity)
        const fields_info = this.state.fields_info
        if( Object.keys(fields_info).length ) {
            //merge fields_info e fieldsProps
            fieldsProps = mergeFieldsPropsAndFieldsInfo(fieldsProps,fields_info)
        }

        const actions = this.props.actions ? this.props.actions : null
        const TopActions = this.props.TopActions ? this.props.TopActions : null

        const dense = {dense: this.props.dense}
        const noTitle = this.props.hasOwnProperty('noTitle')
        const noCard = this.props.hasOwnProperty('noCard')
        const cardTitle = this.props.hasOwnProperty('cardTitle')
            ? this.props.cardTitle
            : entity+" #"+id_entity

        let cardProps = {}
        if( noTitle ) cardProps['noTitle'] = true
        if( noCard ) cardProps['noCard'] = true
        cardProps['Content'] = <TableOneRowTransposed
            material
            {...dense}
            hideHeaders
            rowObject={data}
            fieldsProps={fieldsProps}
        />
        if( TopActions ) cardProps['TopActions'] = TopActions
        if( actions ) cardProps['Actions'] = actions

        return <React.Fragment>
            <DashboardCard title={cardTitle} {...cardProps} />
        </React.Fragment>
    }
}

export default ViewEntity